/**
 * Panel Store
 * Manages panel state (react-router ready for future)
 */

import type { RefObject } from 'react';
import { create } from 'zustand';

// Define specific content types for type safety
export type PanelContent =
  | null // Empty panels or panels without data
  | { mmsi: number | string; [key: string]: unknown } // Vessel content
  | { id: number | string; name?: string; description?: string; [key: string]: unknown } // Rule/Fleet content
  | 'create'; // Special mode for fleet creation

export interface Panel {
  name: string;
  content: PanelContent;
}

interface PanelStore {
  panel: Panel;
  pinned: boolean;
  panelRef: RefObject<HTMLDivElement> | null;

  // Actions
  setPanel: (panel: Panel) => void;
  setPinned: (pinned: boolean) => void;
  setPanelRef: (ref: RefObject<HTMLDivElement> | null) => void;
}

export const usePanelStore = create<PanelStore>((set) => ({
  panel: {
    name: 'Empty',
    content: null,
  },
  pinned: true,
  panelRef: null,

  setPanel: (panel) => {
    set({ panel });
    // Future: Can sync with react-router here
    // navigate(`/panel/${panel.name}`);
  },

  setPinned: (pinned) => set({ pinned }),
  setPanelRef: (ref) => set({ panelRef: ref }),
}));
